import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import Money from 'utils/Money';

const Price = ({ value }) => (
  <div className="Price">
    {new Money(value).format()}
    <style jsx>
      {`
        .Price {
          font-weight: ${Theme.get('font-weight-normal')};
          font-size: ${Theme.get('font-size-px')};
          margin-left: ${Theme.get('spacing') * 2}px;
          flex-shrink: 0;
          padding-top: ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
  </div>
);

Price.propTypes = {
  value: PropTypes.number.isRequired,
};

Price.defaultProps = {};

export default Price;
